export default __webpack_public_path__ + "static/media/hang.23b0f707.svg";